import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import StringUtils from 'helpers/stringUtils';

const stringUtils = new StringUtils();

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 40,
    backgroundColor: 'white',
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    color: 'red',
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 10,
    textAlign: 'center',
    marginBottom: 15,
  },
  table: {
    width: '100%',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    padding: 5,
  },
  tableHeaderCell: {
    color: 'white',
    fontSize: 9,
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: 'white',
  },
  tableRowAlt: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: '#f9f9f9',
  },
  firstNameColumn: {
    flex: 1.5,
    fontSize: 9,
  },
  lastNameColumn: {
    flex: 1.5,
    fontSize: 9,
  },
  dlColumn: {
    flex: 1.5,
    fontSize: 9,
  },
  stateColumn: {
    flex: 1.5,
    fontSize: 9,
  },
  experienceColumn: {
    flex: 1,
    fontSize: 9,
    textAlign: 'center',
  },
  dobColumn: {
    flex: 1.5,
    fontSize: 9,
  },
});

const DriverSchedule = ({ drivers }) => (
  <>
    <Text style={styles.title}>Driver Schedule</Text>
    <Text style={styles.subtitle}>
      It is hereby noted and agreed that the vehicle(s) and trailer(s)
      specified in the schedule are only covered while being operated
      by the following person(s):
    </Text>

    <View style={styles.table}>
      <View style={styles.tableHeader}>
        <Text
          style={[styles.tableHeaderCell, styles.firstNameColumn]}
        >
          First Name
        </Text>
        <Text style={[styles.tableHeaderCell, styles.lastNameColumn]}>
          Last Name
        </Text>
        <Text style={[styles.tableHeaderCell, styles.dlColumn]}>
          DL #
        </Text>
        <Text style={[styles.tableHeaderCell, styles.stateColumn]}>
          DL State
        </Text>
        <Text
          style={[styles.tableHeaderCell, styles.experienceColumn]}
        >
          Years Exp.
        </Text>
        <Text style={[styles.tableHeaderCell, styles.dobColumn]}>
          DOB
        </Text>
      </View>

      {drivers?.map((driver, index) => (
        <View
          key={index}
          style={
            index % 2 === 0 ? styles.tableRow : styles.tableRowAlt
          }
        >
          <Text style={styles.firstNameColumn}>
            {driver.firstName}
          </Text>
          <Text style={styles.lastNameColumn}>{driver.lastName}</Text>
          <Text style={styles.dlColumn}>{driver.licenseNumber}</Text>
          <Text style={styles.stateColumn}>
            {stringUtils.getStateByAbbreviation(driver.licenseState)}
          </Text>
          <Text style={styles.experienceColumn}>
            {driver.yearsExperience}
          </Text>
          <Text style={styles.dobColumn}>{driver.dateOfBirth}</Text>
        </View>
      ))}
    </View>
  </>
);

export default DriverSchedule;
